import {Media, MediaState} from '../interfaces';

export const mutations = {
  SET_MEDIAS(state: MediaState, medias: Media[]): void {
    state.medias = medias;
  },
};
